module.exports = __webpack_public_path__ + "06416a1924c8dee0b7cba7e47b619b0e.svg";